interface Widget {
  c: string;
  locale: string;
  query: string;
  token: string;
  widget: string;
}

const KeyMetricsPage = (function () {
  const $keyMetricsWidgets = $(".js-key-metrics-page-widget");
  const $iFrame = $(".js-key-metrics-iframe");
  const $animateListingArea = $(".js-animate-listing-area");

  function init() {
    if ($keyMetricsWidgets.length > 0) {
      loadDatablockWidgets();
      arrangeStockCalculatorInput();
      setupTabs();
    }
    if ($iFrame.length > 0) {
      showIframeAndResize();
    }
  }

  // Script to load datablocks from ModularFinance.
  // Provided by ModularFinance Jan 2021, updated to v5 2026
  // More info: https://modfin.gitbook.io/datablocks/-LYRjiiPF4zveC0T_zB_/integration/js-loader
  function loadDataBlock(widgets: Widget[]) {
    const url = "https://widget.datablocks.se/api/rose";
    if (!window._MF) {
      const b = document.createElement("script");
      b.type = "text/javascript";
      b.async = true;
      b.src = url + "/assets/js/loader-v5.js";
      document.getElementsByTagName("body")[0].appendChild(b);
    }
    window._MF = window._MF || {
      data: [],
      url,
      ready: !!0,
      render: function () {
        window._MF.ready = !0;
      },
      push: function (w) {
        window._MF.data.push(w);
      },
    };
    window._MF.push(widgets);
  }

  function loadDatablockWidgets() {
    const allDatablocksData = [] as Widget[];
    $keyMetricsWidgets.each(function () {
      allDatablocksData.push({
        c: $(this).data("c-token"),
        locale: $(this).data("locale"),
        query: "#" + $(this).attr("id"),
        token: $(this).data("token"),
        widget: $(this).data("widget-type"),
      });
    });
    loadDataBlock(allDatablocksData);
  }

  function arrangeStockCalculatorInput() {
    let timesRun = 0;
    const handle = setInterval(
      hideDefaultInputandAppendMappedSelectAndInput,
      100,
    ); // Handle time before stock calculator is loaded

    function hideDefaultInputandAppendMappedSelectAndInput() {
      const $keyMetricsWidgetStockCalculator = $("#mf_stockCalculator");
      const $numberAndValueWrapper = $keyMetricsWidgetStockCalculator.find(
        ".mf_number-of-shares",
      );
      const $numberOfSharesInput =
        $numberAndValueWrapper.find("#mf_numberOfShares");
      const $numberOfSharesLabel = $numberAndValueWrapper.find(
        '[for="mf_numberOfShares"]',
      );
      const $valueInput = $numberAndValueWrapper.find("#mf_value");
      const $valueLabel = $numberAndValueWrapper.find('[for="mf_value"]');
      const $inputWrappers = $numberAndValueWrapper.find(".mf_input-wrapper");

      if (
        $keyMetricsWidgetStockCalculator.length > 0 &&
        $numberAndValueWrapper.length > 0 &&
        $numberOfSharesInput.length > 0 &&
        $numberOfSharesLabel.length > 0 &&
        $valueInput.length > 0 &&
        $valueLabel.length > 0 &&
        $inputWrappers.length > 0
      ) {
        $inputWrappers.hide();

        const $stockCalculatorSelect = $numberAndValueWrapper.appendCalcSelect(
          $numberOfSharesLabel.text().replace(":", ""),
          $valueLabel.text().replace(":", ""),
        );
        $stockCalculatorSelect.on("change", function () {
          if (
            $stockCalculatorSelect.val() === "nbrShare" &&
            $valueInput.val() !== ""
          ) {
            $numberOfSharesInput.val($valueInput.val()!).trigger("keyup");
          } else if (
            $stockCalculatorSelect.val() === "value" &&
            $numberOfSharesInput.val() !== ""
          ) {
            $valueInput.val($numberOfSharesInput.val()!).trigger("keyup");
          }
        });

        const $stockCalculatorInput = $numberAndValueWrapper.appendCalcInput();
        $stockCalculatorInput.on("input", function () {
          if ($stockCalculatorSelect.val() === "nbrShare") {
            $numberOfSharesInput.val($(this).val()!).trigger("keyup");
          } else if ($stockCalculatorSelect.val() === "value") {
            $valueInput.val($(this).val()!).trigger("keyup");
          }
        });

        clearInterval(handle);
      } else if (++timesRun >= 20) {
        clearInterval(handle);
      }
    }
  }

  function showIframeAndResize() {
    $iFrame.iFrameResize({ log: false, tolerance: 10, checkOrigin: false });

    $iFrame.on("load", function () {
      $animateListingArea.css("visibility", "visible");
      $animateListingArea.animate({ opacity: 1 }, 1000);
    });
  }

  function setupTabs() {
    function selectTab($newTab: JQuery<HTMLElement>) {
      const ariaControls = $newTab.attr("aria-controls");
      const isSelected = $newTab.attr("aria-selected") === "true";

      if (!isSelected) {
        // Handle the previously active button and widget
        const $siblingButton = $newTab
          .siblings(".js-key-metrics-page__tabs-button")
          .first();
        $siblingButton
          .attr("aria-selected", "false")
          .attr("tabindex", "-1")
          .removeClass("active");

        // Handle the new active button and widget
        $newTab
          .attr("aria-selected", "true")
          .removeAttr("tabindex")
          .addClass("active")
          .focus();
        const newTabId = $newTab.attr("aria-controls");
        $(`#${newTabId}`).attr("tabindex", "0");

        const siblingWidgetId = $siblingButton.attr("aria-controls");
        $(`#${siblingWidgetId}`)
          .removeAttr("tabindex")
          .fadeOut(100, function () {
            $(`#${ariaControls}`).fadeIn(100);
          });
      }
    }

    $(".js-key-metrics-page__tabs-button").on("click", function () {
      selectTab($(this));
    });

    $(".js-key-metrics-page__tabs-button").on("keydown", function (event) {
      const $currentTab = $(this);
      let $newTab;

      if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
        event.preventDefault();
        $newTab = $currentTab.siblings("button").first();
        selectTab($newTab);
      }
    });
  }

  $.fn.appendCalcSelect = function (
    numberOfSharesLabel,
    valueLabel,
  ): JQuery<HTMLElement> {
    $(this).append($('<select id="calc-type">'));
    const $select = $(this).find("#calc-type");
    const options = [
      { val: "nbrShare", text: numberOfSharesLabel },
      { val: "value", text: valueLabel },
    ];

    options.forEach((option) => {
      $select.append($("<option>").attr("value", option.val).text(option.text));
    });

    return $select;
  };

  $.fn.appendCalcInput = function (): JQuery<HTMLElement> {
    $(this).append($('<input id="calc-value" type="number" min="0" step="1">'));
    return $(this).find("#calc-value");
  };

  return {
    init,
  };
})();

export default KeyMetricsPage;
